import { Link } from "gatsby"
import React, { useContext } from "react"
import {
  GlobalStateContext,
  GlobalDispatchContext,
} from "../context/GlobalContextProvider"
import History from "./history"
import styled from "styled-components"
import vars from "../styles/vars"
import logo from "../images/gls-logo.svg"
import logoColors from "../images/gls-logo-colors.svg"
import darkIcon from "../images/dark.svg"
import lightIcon from "../images/light.svg"
import helpDarkIcon from "../images/help-dark.svg"
import helpLightIcon from "../images/help-light.svg"
import libraryDarkIcon from "../images/library-dark.svg"
import libraryLightIcon from "../images/library-light.svg"

const Header = styled.header`
  position: relative;
  z-index: 100;
  left: 0;
  right: 0;
  top: 0;
  margin: 0 auto;
  max-width: 1790px;
  padding-left: 16px;
  padding-right: 16px;

  @media ${vars.mq.tablet.query} {
    padding-left: 32px;
    padding-right: 32px;
  }

  @media ${vars.mq.desktopLarge.query} {
    padding-left: 64px;
    padding-right: 64px;
  }
`

const LogoWrapper = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  padding-top: 24px;

  @media ${vars.mq.desktop.query} {
    padding-top: 40px;
  }

  @media ${vars.mq.desktopLarge.query} {
    padding-top: 50px;
  }

  @media ${vars.mq.desktop.query} and (max-height: 799px) {
    padding-top: 24px;
  }
`

const Logo = styled(Link)`
  display: block;
  width: 160px;

  img {
    margin: 0;
    display: block;
  }
`

const MenuWrapper = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  padding-top: 24px;

  @media ${vars.mq.desktop.query} {
    position: fixed;
    padding-top: 40px;
    right: auto;
    left: ${({ infoColOffset }) =>
      infoColOffset - vars.gridGap / 2 - vars.gridGap}px;
    transform: translateX(-100%);
  }

  @media ${vars.mq.desktopLarge.query} {
    padding-top: 50px;
    left: ${({ infoColOffset }) =>
      infoColOffset - vars.gridGapLg / 2 - vars.gridGapLg}px;
  }

  @media ${vars.mq.desktop.query} and (max-height: 799px) {
    padding-top: 24px;
  }
`

const FlexWrapper = styled.div`
  display: flex;
  justify-content: ${({ justifyContent }) => justifyContent ?? "flex-start"};

  & + & {
    margin-top: 20px;
  }
`

const Action = styled.button`
  display: ${({ hiddenXS }) => (hiddenXS ? "none" : "flex")};
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: ${({ lightMode }) =>
    lightMode ? vars.colors.grayDark : vars.colors.gray};
  font-size: 0.75rem;
  line-height: 1;
  text-align: center;
  cursor: pointer;

  @media ${vars.mq.desktop.query} {
    display: flex;
  }

  & + & {
    margin-left: 10px;
  }

  img {
    width: 20px;
    height: 20px;
    margin-bottom: 0.25em;
  }
`

export default () => {
  const dispatch = useContext(GlobalDispatchContext)
  const { lightMode, infoColOffset } = useContext(GlobalStateContext)

  return (
    <Header>
      {/* Logo */}
      <LogoWrapper>
        <Logo to="/">
          <img src={lightMode ? logoColors : logo} alt="GLS Bank" />
        </Logo>
      </LogoWrapper>

      <MenuWrapper infoColOffset={infoColOffset}>
        {/* Actions */}
        <FlexWrapper>
          {/* Imprint */}
          <Action
            as={"a"}
            href="https://www.gls.de/privatkunden/impressum/"
            target="_blank"
            lightMode={lightMode}
          >
            <img
              src={lightMode ? libraryDarkIcon : libraryLightIcon}
              alt="Impressum"
            />
            Impressum
          </Action>

          {/* Help */}
          <Action
            lightMode={lightMode}
            hiddenXS
            onClick={e => {
              // Toggle help overlay
              dispatch({
                type: "SET_HELP_OVERLAY",
                showHelpOverlay: true,
              })

              // Prevent standard link behaviour
              e.currentTarget.blur()
              e.preventDefault()
            }}
          >
            <img src={lightMode ? helpDarkIcon : helpLightIcon} alt="Hilfe" />
            Hilfe
          </Action>

          {/* Light/dark */}
          <Action
            lightMode={lightMode}
            onClick={e => {
              // Toggle light mode
              dispatch({
                type: "TOGGLE_LIGHT_MODE",
              })

              // Prevent standard link behaviour
              e.currentTarget.blur()
              e.preventDefault()
            }}
          >
            <img src={lightMode ? darkIcon : lightIcon} alt="Light/Dark Mode" />
            {lightMode ? "Dunkel" : "Hell"}
          </Action>
        </FlexWrapper>
        <FlexWrapper justifyContent="flex-end">
          <History />
        </FlexWrapper>
      </MenuWrapper>
    </Header>
  )
}
